module.exports = __webpack_public_path__ + "img/pre_20211001_logo.960d7490.png";